import ChainId from "./chainId";
import { DEFAULT_CHAIN_ID } from ".";
import USDC from "@/assets/tokens/usdc.png";
import UNI from "@/assets/tokens/uni.png";
import WETH from "@/assets/tokens/weth.png";

interface TokenInfo {
  chainId: number;
  address: `0x${string}`;
  decimals: number;
  symbol: string;
  name: string;
  icon: string;
  recommended?: boolean;
}

export const tokenList: TokenInfo[] = [
  {
    address: "0x0000000000000000000000000000000000000000",
    symbol: "ETH",
    decimals: 18,
    name: "Ether",
    chainId: ChainId.SEPOLIA,
    icon: WETH,
    recommended: true,
  },
  {
    address: "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
    symbol: "WETH",
    decimals: 18,
    name: "Wrapped Ether",
    chainId: ChainId.SEPOLIA,
    icon: WETH,
    recommended: true,
  },
  {
    address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    symbol: "USDC",
    decimals: 6,
    name: "USDC",
    chainId: ChainId.SEPOLIA,
    icon: USDC,
    recommended: true,
  },
  {
    address: "0xc07D3363f3703565bfd11C22603f9CA7D692aCe2",
    symbol: "UNI",
    decimals: 18,
    name: "UNI",
    chainId: ChainId.SEPOLIA,
    icon: UNI,
  },
];

export const ethInfo = tokenList.find(
  (token) => token.symbol === "ETH" && token.chainId === DEFAULT_CHAIN_ID
)!;

export const usdcInfo = tokenList.find(
  (token) => token.symbol === "USDC" && token.chainId === DEFAULT_CHAIN_ID
)!;

export const wethInfo = tokenList.find(
  (token) => token.symbol === "WETH" && token.chainId === DEFAULT_CHAIN_ID
)!;

export const ethAddress = "0x0000000000000000000000000000000000000000";
